import { Link } from 'react-router-dom';

const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '权威可溯',
    desc: '每一站点均经过人工筛选与来源核验，只收录值得信赖的资源。',
  },
  {
    icon: 'ri-folders-line',
    title: '分类清晰',
    desc: '多领域多级分类体系，配合标签与筛选，快速定位所需网站。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '检索高效',
    desc: '支持关键词检索与多维筛选排序，几秒内找到目标入口。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更新',
    desc: '每日补充优质站点并清理失效链接，保持目录长期可用。',
  },
];

export default function AboutIntro() {
  return (
    <section className="w-full border-t border-background-200 bg-secondary-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="mx-auto max-w-[1280px]">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_1.4fr] lg:items-center">
            <div>
              <span className="text-xs font-medium uppercase tracking-wide text-primary-600">关于网址大全</span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                让每一次找网站都更简单可靠
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                网址大全是一个面向普通网民、企业用户与行业从业者的综合网站目录平台。我们以专业、中立、易用为原则，
                把散落在互联网各处的优质站点整理成清晰可检索的目录，帮助你在最短时间内找到真正需要的入口。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  了解更多
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  提交收录申请
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {advantages.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}